import React, { useState } from "react";
import "./Research.css";

// const LOREM = [
//   "Vivamus facilisis tellus vel sem convallis, ut gravida arcu ullamcorper. Curabitur at mauris in urna euismod.",
//   "Donec vitae arcu sit amet augue placerat rhoncus. Suspendisse potenti. In hac habitasse platea dictumst.",
//   "Sed posuere nibh eget risus finibus, vitae rutrum ipsum fringilla. Cras vitae nisl id est fermentum.",
//   "Nullam a magna et felis posuere pharetra. Quisque vitae quam in nunc vehicula interdum.",
//   "Aenean euismod risus at arcu hendrerit, ac sodales purus facilisis. Pellentesque habitant morbi tristique.",
//   "Mauris mattis, odio at dapibus aliquam, augue purus posuere mi, sed sodales purus nulla eu arcu.",
//   "Phasellus dictum tellus vitae nisl varius, nec condimentum quam pulvinar. Etiam non massa eu eros.",
//   "Proin ut risus nec nibh luctus lacinia. Aliquam et augue a felis semper malesuada.",
// ];

const DATA = {
  working: [
    {
      title:
        "Local Officials in Imperial Administration and Long-Run Development in Ukraine",
      authors: "",
      abstract:
        "Where more locals staffed courts, police, and administration, Ukrainian communities collect more tax and govern more effectively today. Regions entered the Russian Empire with different traditions of self-rule, leaving variation in who held local office. Using newly transcribed 1897 census records, I measure the share of local officials and link it to modern communities. A 10-percentage-point increase in local representation is associated with 7.1% higher local tax revenue per capita in 2021. An IV strategy supports the results, which survive a battery of robustness checks. I argue that self-governance built durable local institutions that persisted across imperial and Soviet rule.",
      citation:
        "Melnyk, M. (2026). Local Officials in Imperial Administration and Long-Run Development in Ukraine. Economists for Ukraine Working Paper No. 33.",
      url: "/Econ4UA-Working-Paper-No33_mmelnyk.pdf",
      download: true,
    },
  ],
  journals: [{ title: "", text: "Coming soon..." }],
  other: [
    {
      title:
        "ENG: Local elections 2020 and gender quotas: pros, cons, pitfalls",
      text: "Policy note on design trade-offs and implementation risks for gender quotas in local elections.",
      url: "https://kse.ua/wp-content/uploads/2021/11/KSE_Genderni-kvoti_T.Brik.pdf",
    },
    {
      title:
        "UA: Чи служать партії народу? У пошуках партійних осередків напередодні місцевих виборів",
      text: "Аналітична публікація про локальні осередки партій та їхню роль перед місцевими виборами.",
      url: "https://voxukraine.org/chi-sluzhat-partiyi-narodu-u-poshukah-partijnih-oseredkiv-naperedodni-mistsevih-viboriv",
    },
  ],
};

// Authorship standard: all co-authors listed in one set of parentheses,
// in alphabetical order by surname.
const WORK_IN_PROGRESS = [
  {
    title:
      "Work from Home and Disability Employment: Not All Barriers Are Equal",
    authors: "L. Maliar, M. Melnyk",
  },
  {
    title: "Serfdom, concentration, and emancipation in the Russian Empire",
    authors: "J. Conning, M. Melnyk",
  },
  {
    title:
      "Cross-border Mobility and Local Development: Evidence from a Multi-Border Natural Experiment",
    authors: "M. Melnyk",
  },
];

export default function Research() {
  const [tab, setTab] = useState("working");
  const items =
    tab === "working"
      ? DATA.working
      : tab === "journals"
        ? DATA.journals
        : DATA.other;

  return (
    <main className="research">
      <div className="research-inner">
        <h1 className="research-title">Research</h1>
        <p>
          My research studies how institutions, labor markets, and technology
          shape productivity, economic participation, and long-run development.
          I work primarily at the intersection of labor economics,
          macroeconomics, and political economy, often using historical settings
          to study broader questions about the well-being of individuals and
          societies.
        </p>

        <div className="research-tabs">
          <button
            className={`research-tab ${tab === "working" ? "active" : ""}`}
            onClick={() => setTab("working")}
          >
            Working papers
          </button>
          <button
            className={`research-tab ${tab === "journals" ? "active" : ""}`}
            onClick={() => setTab("journals")}
          >
            Academic journals
          </button>
          <button
            className={`research-tab ${tab === "other" ? "active" : ""}`}
            onClick={() => setTab("other")}
          >
            Other publications
          </button>
        </div>

        <div className="research-list">
          {items.map((it, i) => (
            <div className="research-card" key={i}>
              {it.title && (
                <h3 className="research-card-title">
                  {it.title}
                  {it.authors ? ` (${it.authors})` : ""}
                </h3>
              )}
              {it.text && <p className="research-card-text">{it.text}</p>}
              {it.abstract && (
                <>
                  <h4 className="research-card-label">Abstract</h4>
                  <p className="research-card-text">{it.abstract}</p>
                </>
              )}
              {it.citation && (
                <>
                  <h4 className="research-card-label">Citation</h4>
                  <p className="research-card-text">{it.citation}</p>
                </>
              )}
              {it.url && (
                <p>
                  <a
                    href={it.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="research-link"
                    {...(it.download ? { download: true } : {})}
                  >
                    {it.download ? "Download paper" : "View publication"}
                  </a>
                </p>
              )}
            </div>
          ))}

          {tab === "working" && (
            <div className="research-card">
              <h3 className="research-card-title">Work in progress</h3>
              <ul className="research-wip">
                {WORK_IN_PROGRESS.map((w, i) => (
                  <li key={i} className="research-card-text">
                    {w.title} ({w.authors})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
